
<template>
  <div class="container">
    <div class="top">
      <div class="icon">
        <img
          v-if="info.Icon"
          v-bind:src="info.Icon"
          v-bind:alt="info.FullName"
          style="display:block; width: 50px; height: 50px; border-radius: 50%;"
        />
        <span class="flow-avatar" v-else v-bind:title="info.FullName">{{ showName(info.ApplicantName) }}</span>
      </div>
      <div class="name">
        <p>{{ApplicantName}}提交的{{info.ApplicationType === 2?'代':''}}请假申请</p>
        <p class="schoolNumber">{{info.CreateByDate}}</p>
      </div>
    </div>

    <div class="middle">
      <div class="status-icon">
        <!-- 移动端请假审批详情页，审批中的状态图标需去掉，和PC端保持一致。 -->
        <!-- <img src="~@/assets/attendance/approval-1.png" alt="" v-if="ApplicationStateName === '审批中'"> -->
        <img src="~@/assets/attendance/approval-2.png" alt="" v-if="ApplicationStateName === '已通过'">
        <img src="~@/assets/attendance/approval-3.png" alt="" v-if="ApplicationStateName === '已拒绝'">
        <img src="~@/assets/attendance/approval-4.png" alt="" v-if="ApplicationStateName === '已撤销'">
      </div>
      <div class="content" v-for="item in list" :key="item.name">
        <div>{{item.name}}</div>
        <div :class="{'flex-column':item.name === '周期性请假'}" v-html="item.value"></div>
      </div>
    </div>

    <div class="footer">
      <div class="foot-cont">
        <div class="foot-cont-item">
          <van-cell center
                    title="审批流程"></van-cell>
          <ApprovalFlow :dataList="barchData"
                        style=" padding: 0 20px;"></ApprovalFlow>
        </div>
        <div class="foot-cont-item" v-if="!disLook">
          <div class="foot-top">
            <van-field
              style="height: 100px"
              clearable
              required
              type="textarea"
              label="审批意见"
              :maxlength="100"
              placeholder="请输入审批意见"
              v-model="DeniedDescription"
            ></van-field>
          </div>
        </div>
      </div>
      <div class="foot-btn" v-if="!disLook">
        <van-button class="btn" round plain type="info" @click="submit(3)">拒绝</van-button>
        <van-button class="btn" round type="info" @click="submit(2)">同意</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import ApprovalFlow from "../../../../components/workFlow/ApprovalFlow";
const approvalImg = [
  require("@/assets/attendance/approval-1.png"),
  require("@/assets/attendance/approval-2.png"),
  require("@/assets/attendance/approval-3.png"),
  require("@/assets/attendance/approval-4.png"),
  require("@/assets/attendance/approval-5.png")
];
export default {
  props: {},
  components: {
    ApprovalFlow
  },
  name: "ApprovalDetails",
  data() {
    return {
      approvalImg,
      imgUrl: this.xyMApi + '/att',
      list: [
        {
          name: "请假类型",
          value: ""
        },
        {
          name: "请假学生",
          value: ""
        },
        {
          name: "周期性请假",
          value: ""
        },
        {
          name: "请假原因",
          value: ""
        },
        {
          name: "是否离校",
          value: ""
        },
        {
          name: "图片",
          value: ""
        }
      ],

      ApprovalFlowNodes: [],
      barchData: [],

      ServiceDoMainName: "",
      disLook: true,
      dataNews: "暂无消息",
      code: "",
      DeniedDescription: "",
      approvalData: {
        Option: "",
        currentNode: undefined,
        TeacherApplicationID: undefined
      },
      Status: "",
      Option: "",
      imgName: "",
      IsAgree: "",
      LeaveApplicationID: "",
      ApplicationState: "",
      ApplicationStateName: "",
      StudentIcon: "",
      Icon: "",
      iconShow: false,
      ApplicantName: "",
      userBaseInfo: "",
      isRevoke: true,
      type: "",
      info: "",
      LeaveApplicationVal: "",
      DetailParameter: "",
      baseApi: ""
    };
  },
  created() {
    this.baseApi = this.xyMApi + '/base';
    this.ServiceDoMainName = `${this.xyMApi}/att`
    // console.log(this.ServiceDoMainName);
    // 判断是否是从消息列表里传来的值
    if (this.$route.query.fromMessage) {
      this.messageInfo = JSON.parse(this.$store.state.messageInfo);
      // console.log(this.messageInfo);
      // 字符串转json
      this.DetailParameter = JSON.parse(this.messageInfo.Body);
      if (this.DetailParameter !== null) {
        this.LeaveApplicationID = this.DetailParameter.LeaveApplicationID
      }
    } else {
      // 从列表跳转
      // this.$store.state.apiPath
      this.type = this.$store.state.attendance.type;
      this.LeaveApplicationVal = this.$store.state.attendance.val;
      this.LeaveApplicationID = this.LeaveApplicationVal.LeaveApplicationID;
    }
  },
  mounted: function() {
    this.getRows();
  },
  methods: {
    // 获取上一页参数
    async getRows() {
      // 获取当前用户基本信息
      this.userBaseInfo = this.$store.state.common.userInfo;
      this.isRevoke = this.$route.query.isRevoke;
      let params = {
        LeaveApplicationID: this.LeaveApplicationID
      };
      let res = await this.xyapi.get(
        this.ServiceDoMainName + "/api/StudentLeaveMb/GetStudentLeaveByIDMobile",
        params
      );
      if (res.success) {
        this.info = res.data.LeaveModel;
        this.ApprovalFlowNodes = res.data.ApprovalFlowNodes;
        this.barchData = res.data.ApprovalFlowNodes;
        // 需要循环图片
        var Images = "";
        if (this.info.Images !== null || this.info.Images.length > 0) {
          for (let i = 0; i < this.info.Images.length; i++) {
            Images =
              Images +
              "<img style='width: 80px; height: 80px; margin: 0 8px 18px 0px;' src='" +this.imgUrl + "" +this.info.Images[i] +   "' />";
              
           
          }
        }
        // 需要循环周期性请假
        var CycleDetail = "";
        if (this.info.IsCycleLeave) {
          for (let i = 0; i < this.info.CycleDetail.length; i++) {
            CycleDetail =
              CycleDetail + "<div>" + this.info.CycleDetail[i] + "</div>";
          }
        }
        
        // 需要循环学生
        var SubstituteNameList = "";
        if (this.info.Details.length > 0) {
          for (var i = 0; i < this.info.Details.length; i++) {
            SubstituteNameList = SubstituteNameList + "<span style='display: inline-block; margin: 5px;'>" + this.info.Details[i].StudentName + "</span>";
          }
        }

        // 内容
        this.list[0].value = this.info.LeaveTypeName;
        this.list[1].value =
          this.info.Details.length === 0
            ? this.info.SubstituteName
            : SubstituteNameList;

        this.list[2].value = this.info.IsCycleLeave
          ? "<div >是</div> " + CycleDetail
          : "<div >否</div>"+this.xy.moment(this.info.StartTime ).format("YYYY-MM-DD HH:mm")+ "~" + this.xy.moment(this.info.EndTime ).format("YYYY-MM-DD HH:mm");

        this.list[3].value = this.info.ApplicationDescription;
        this.list[4].value = this.info.IsLeaveSchool ? "是" : "否";
        this.list[5].value = this.info.Images.length > 0 ? Images : "无";

        // 头部
        if (this.info.LeaveApplicationID !== 0) {
          this.DeniedDescription = this.info.DeniedDescription;
          this.ApplicationState = this.info.ApplicationState;
          this.ApplicationStateName = this.info.ApplicationStateName + "";
          this.ApplicantName = this.info.ApplicantName + "";
          if (this.info.Icon === "" || this.info.Icon === null) {
            this.iconShow = false;
          } else {
            this.iconShow = true;
            this.Icon = this.info.Icon;
          }
          if (this.ApplicationState === 0 || this.ApplicationState === 1) {
            this.disLook = false
          }
        } else {
          this.dataNews = "对不起，此信息已被删除";
        }

        var _this = this;
        // 审批流程
        this.ApprovalFlowNodes.forEach((element) => {
          // 缩略预览模式开关
          element.isOverviewMode = true;
          // 缩略预览列表(不大于5个)
          element.overviewList = [];
          // 若该审批项目结束，缩略列表显示最后审批结果的时间与状态
          element.lastComplete_time = undefined;
          element.lastComplete_status = undefined;
          element.ApprovalMemberList.forEach((memberItem, memberIndex) => {
            // 缩略图列表仅显示前4个，其余显示省略号；若共5人，则不显示省略号，直接全部显示
            if (memberIndex < 4 || element.ApprovalMemberList.length === 5) {
              element.overviewList.push(memberItem);
            }
            // 该审批流是否完成
            if (element.IsComplete === 1 || element.IsComplete === true) {
              if (element.lastCompleteTime) {
                var lastTime = new Date(element.lastComplete_time);
                var thisTime = new Date(memberItem.ApprovalDate);
                if (memberItem.Status !== "0" && thisTime > lastTime) {
                  element.lastComplete_time = memberItem.ApprovalDate;
                  element.lastComplete_status = memberItem.Status;
                }
              } else {
                if (memberItem.Status !== "0") {
                  element.lastComplete_time = memberItem.ApprovalDate;
                  element.lastComplete_status = memberItem.Status;
                }
              }
            }
          })
          if (element.StatusName === '待审批') {
            if (element.ApprovalFlowNodeName === '会签') {
              // element.WorkFlowNodeType === 2是审批节点
              // 获取当前需审批的节点：第一个非完成节点
              if (this.approvalData.currentNode === undefined && element.ApprovalFlowNodeName !== '发起人' && !element.IsComplete) {
                this.approvalData.currentNode = element
              }
              for (var i = 0; i < element.ApprovalMemberList.length; i++) {
                // 循环当前节点下的所有人
                if (element.ApprovalMemberList[i].UserID === this.$store.state.common.userInfo.UserID) {
                  // 找到当前用户  Status = 0 待审批, 2 已通过，3 已拒绝
                  if (element.ApprovalMemberList[i].Status !== '待审批') {
                    // 判断当前用户的状态
                    this.Status = element.ApprovalMemberList[i].StatusName
                    this.Option = element.ApprovalMemberList[i].Option
                    this.disLook = true
                    return
                  } else {
                    if (this.approvalData.currentNode !== undefined && this.approvalData.currentNode.ApprovalFlowNodeID === element.ApprovalFlowNodeID) {
                      this.disLook = false
                      return
                    }
                  }
                }
              }
            }
            if (element.ApprovalFlowNodeName === '或签') {
              // element.WorkFlowNodeType === 2是审批节点
              // 获取当前需审批的节点：第一个非完成节点
              if (this.approvalData.currentNode === undefined && element.ApprovalFlowNodeName !== '发起人' && !element.IsComplete) {
                this.approvalData.currentNode = element
              }
              for (var c = 0; c < element.ApprovalMemberList.length; c++) {
                // 循环当前节点下的所有人
                if (element.ApprovalMemberList[c].UserID === this.$store.state.common.userInfo.UserID) {
                  // 找到当前用户  Status = 0 待审批, 2 已通过，3 已拒绝
                  if (element.ApprovalMemberList[c].Status !== '待审批') {
                    // 判断当前用户的状态
                    this.Status = element.ApprovalMemberList[c].StatusName
                    this.Option = element.ApprovalMemberList[c].Option
                    this.disLook = true
                    return
                  } else {
                    if (this.approvalData.currentNode !== undefined && this.approvalData.currentNode.ApprovalFlowNodeID === element.ApprovalFlowNodeID) {
                      this.disLook = false
                      return
                    }
                  }
                }
              }
            }
          } else {
            if (element.ApprovalFlowNodeName === '会签') {
              // element.WorkFlowNodeType === 2是审批节点
              // 获取当前需审批的节点：第一个非完成节点
              if (this.approvalData.currentNode === undefined && element.ApprovalFlowNodeName !== '发起人' && !element.IsComplete) {
                this.approvalData.currentNode = element
              }
              for (var a = 0; a < element.ApprovalMemberList.length; a++) {
                // 循环当前节点下的所有人
                console.log(element.ApprovalMemberList[a].UserID)
                console.log(this.$store.state.common.userInfo.UserID)
                if (element.ApprovalMemberList[a].UserID === this.$store.state.common.userInfo.UserID) {
                  // 找到当前用户  Status = 0 待审批, 2 已通过，3 已拒绝
                  if (element.ApprovalMemberList[a].Status !== '待审批') {
                    // 判断当前用户的状态
                    this.Status = element.ApprovalMemberList[a].StatusName
                    this.Option = element.ApprovalMemberList[a].Option
                    this.disLook = true
                    return
                  } else {
                    if (this.approvalData.currentNode !== undefined && this.approvalData.currentNode.ApprovalFlowNodeID === element.ApprovalFlowNodeID) {
                      this.disLook = false
                      return
                    }
                  }
                }
              }
            }
            if (element.ApprovalFlowNodeName === '或签') {
              // element.WorkFlowNodeType === 2是审批节点
              // 获取当前需审批的节点：第一个非完成节点
              if (this.approvalData.currentNode === undefined && element.ApprovalFlowNodeName !== '发起人' && !element.IsComplete) {
                this.approvalData.currentNode = element
              }
              for (var s = 0; s < element.ApprovalMemberList.length; s++) {
                // 循环当前节点下的所有人
                console.log(element.ApprovalMemberList[s].Status)
                // 找到当前用户  Status = 0 待审批, 2 已通过，3 已拒绝
                if (element.ApprovalMemberList[s].Status !== '待审批') {
                  // 判断当前用户的状态
                  this.Status = element.ApprovalMemberList[s].StatusName
                  this.Option = element.ApprovalMemberList[s].Option
                  this.disLook = true
                  return
                } else {
                  if (this.approvalData.currentNode !== undefined && this.approvalData.currentNode.ApprovalFlowNodeID === element.ApprovalFlowNodeID) {
                    this.disLook = false
                    return
                  }
                }
              }
            }
          }
          // 抄送列表，大致逻辑同上
          element.isOverviewMode_CC = true;
          element.overviewList_CC = [];
          element.ApprovalCCMemberList.forEach((CCItem, CCIndex) => {
            // 缩略图列表仅显示前4个，其余显示省略号；若共5人，则不显示省略号，直接全部显示
            if (CCIndex < 4 || element.ApprovalCCMemberList.length === 5) {
              element.overviewList_CC.push(CCItem)
            }
          })
        })

        // 判断是否已经撤销 审批 0 未审批    2已审批（通过，拒绝）4撤销
        if (this.ApplicationState === 4 || this.ApplicationState === 3) {
          _this.disLook = true
        }
      }
    },

    // 审批流列表：若无图标，展示文字
    showName(name) {
      if (name != null) {
        // 纯中文：汉字姓名大于2个字展示最后2个字，小于等于2个字
        if (/^[\u4e00-\u9fa5]+$/g.test(name)) {
          return name.length > 3 ? name.slice(-2) : name;
        } else if (/^[A-Za-z]+$/g.test(name)) {
          // 纯英文名只展示两个字母
          return name.slice(0, 2);
        } else {
          // 其他
          return name.slice(0, 2);
        }
      }
    },

    // 展开或折叠
    setStatus_isOverviewMode(item, index, type, value) {
      if (type === "normal") {
        item.isOverviewMode = value;
      } else if (type === "CC") {
        item.isOverviewMode_CC = value;
      } else {
        item.isOverviewMode = value;
      }
      this.$set(this.ApprovalFlowNodes, index, item);
    },

    // 时间格式化
    xyFormatDate() {
      // format = format || 'MM.dd HH:mm'
      // return date ? xy.date.format(date, format) : ''
    },

    async submit(val) {
      this.xy.loading();
      if (
        this.DeniedDescription === "" ||
        this.DeniedDescription === undefined
      ) {
        this.$toast.fail("请填写审核意见");
        return;
      }
      this.ApplicationState = val;
      // 同意
      if (val === 2) {
        this.IsAgree = true;
      }
      // 拒绝
      if (val === 3) {
        this.IsAgree = false;
      }
      let params = {
        IsAgree: this.IsAgree,
        ApprovalFlowID: this.approvalData.currentNode.ApprovalFlowID,
        ApprovalFlowNodeID: this.approvalData.currentNode.ApprovalFlowNodeID,
        LeaveApplicationID: this.LeaveApplicationID,
        Opinion: this.DeniedDescription, // 审批意见
        ApproveStatus: this.ApplicationState // 同意，拒绝  状态
      };
      let res = await this.xyapi.post(
        this.ServiceDoMainName + "/api/StudentLeaveMb/Approval",
        params
      );
      if (res.success) {
        this.xy.unloading();
        this.$toast.fail(res.data);
        // 跳转回列表页
        this.$router.push("/home/StudentLeave/Approval");
      } else {
        this.xy.unloading();
        this.$toast.fail(res.data);
      }
    }
  }
};
</script>
<style scoped lang="less">
.container {
  padding: 0 20px;
  background: #fff;
  .top {
    height: 130px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #eaeaea;
    .icon {
      flex: 0.2;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .flow-avatar {
        -ms-flex-negative: 0;
        flex-shrink: 0;
        width: 60px;
        height: 60px;
        line-height: 60px;
        background: #4196ff;
        border-radius: 50%;
        font-size: 26px;
        text-align: center;
        color: #fff;
      }
      p {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 70px;
        height: 70px;
        background: rgba(41, 128, 254, 1);
        color: #ffffff;
        font-size: 28px;
        font-weight: bold;
        border-radius: 50%;
      }
    }
    .name {
      flex: 0.75;
      display: flex;
      justify-content: center;
      flex-flow: column nowrap;
      p {
        color: #606060;
        font-size: 24px;
      }
      p:nth-of-type(1) {
        color: #161616;
        font-size: 26px;
        font-weight: bold;
        height: 50%;
        display: flex;
        align-items: center;
      }
    }
  }
  .middle {
    display: flex;
    justify-content: center;
    flex-flow: column nowrap;
    padding: 20px 0;
    border-bottom: 1px solid #eaeaea;
    position: relative;
    .status-icon{
      position: absolute;
      right: 20px;
      top: 50px;
      img{
        width: 140px;
        height: 140px;
      }
    }
    .content {
      display: flex;
      justify-content: space-between;
      min-height: 80px;
      font-size: 24px;
      div:nth-of-type(1) {
        flex: 0.2;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        color: #606060;
        font-size: 26px;
        white-space: nowrap;
      }
      .flex-column{
        flex-direction: column !important;
        align-items: flex-start !important;
      }
      div:nth-of-type(2) {
        flex: 0.75;
        align-items: center;
        display: flex;
        flex-flow: row wrap;
        color: #161616;
        line-height: 1.5;
        //  font-size: 26px;
        .name-tit {
          display: inline-block
        }
        div {
          font-size: 22px;
        }
        .bgm {
          width: 50px;
          height: 50px;
          background: rgba(216, 216, 216, 1);
          border-radius: 2px;
        }
      }
    }
  }
  .footer {
    margin-top: 20px;
    .foot-cont {
      .foot-cont-item {
        .foot-top {
          display: flex;
          justify-content: space-between;
          min-height: 10.667vw;
          font-size: 26px;
          .foot-tit {
            font-size: 26px;
            font-family: PingFang-SC-Regular, PingFang-SC;
            font-weight: 400;
            color: rgba(96, 96, 96, 1);
            flex: 0.2;
            display: flex;
            align-items: center;
            justify-content: flex-end;
          }
          .foot-ent {
            flex: 0.75;
            align-items: center;
            display: flex;
            flex-flow: row wrap;
            color: #161616;
            line-height: 1.5;
          }
        }
        .foot-tit-cont {
          padding: 0 20px;
          // 审批流程
          .flow-wrapper {
            position: relative;
            &>.flow-item:last-child{
              .flow-item-line {
                border-left: 2px solid #fff;
              }
            }
            .flow-item {
              position: relative;
              margin: 0;
              padding: 0 0 24px;
              .flow-item-line {
                height: 100%;
                border-left: 2px solid #c6c6c6;
                position: absolute;
                left: 30px;
                top: 0;
              }
              .flow-item-header {
                width: 60px;
                height: 60px;
                line-height: 60px;
                background-color: #4196ff;
                border-radius: 50%;
                position: absolute;
                z-index: 1;
                color: #fff;
                overflow: hidden;
                .flow-avatar {
                  -ms-flex-negative: 0;
                  flex-shrink: 0;
                  /* line-height: 40px; */
                  background: #4196ff;
                  border-radius: 50%;
                  font-size: 26px;
                  text-align: center;
                  color: #fff;
                }
              }
              .flow-item-content {
                padding: 1px 1px 10px 75px;
                font-size: 26px;
                position: relative;
                top: -3px;
                .flow-content-header {
                  display: -webkit-box;
                  display: -ms-flexbox;
                  display: flex;
                  -webkit-box-pack: justify;
                  -ms-flex-pack: justify;
                  justify-content: space-between;
                  color: #666;
                  .flow-content-title {
                    font-size: 26px;
                    color: #161616;
                  }
                  .flow-content-time {
                    color: #999;
                    font-size: 24px;
                  }
                }
                .flow-content-body {
                  min-height: 1em;
                  .flow-detail-body{
                    margin-top: 5px;
                  }
                  .flow-content-reason {
                    color: #999;
                  }
                }

                .flow-overview-body {
                  display: -webkit-box;
                  display: -ms-flexbox;
                  display: flex;
                  -webkit-box-pack: justify;
                  -ms-flex-pack: justify;
                  justify-content: space-between;
                  .flow-overview-list {
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    .flow-overview-item {
                      margin-top: 6px;
                      margin-right: 10px;
                      .flow-status-bgcolor {
                        position: relative;
                      }
                    }
                  }
                  .flow-content-time {
                    color: #999;
                    font-size: 24px;
                  }
                }
              }
            }
          }

          .flow-avatar {
            -ms-flex-negative: 0;
            flex-shrink: 0;
            width: 60px;
            height: 60px;
            line-height: 60px;
            background: #4196ff;
            border-radius: 50%;
            font-size: 26px;
            text-align: center;
            color: #fff;
          }
          .flow-avatar--small {
            position: relative;
            top: 36px;
            width: 55px;
            height: 55px;
            margin: 0 auto;
            line-height: 55px;
            font-size: 24px;
            overflow: hidden;
            img {
              width: 55px;
              height: 55px;
              border-radius: 50%;
            }
          }
          .flow-avatar > span {
            display: inline-block;
            -webkit-transform: scale(0.9);
            transform: scale(0.9);
            letter-spacing: 1px;
          }
        }
      }
    }

    .flow-icon-radio {
      display: inline-block;
      width: 35px;
      height: 35px;
      margin: 25% 0 0 20%;
      background: url(~@/assets/attendance/radio-white.svg) no-repeat;
      -webkit-transform: scale(1.3);
      transform: scale(1.3);
    }
    .foot-btn {
      display: flex;
      .btn {
        flex: 0.5;
        align-items: center;
        text-align: center;
        justify-content: flex-end;
        margin: 10px;
      }
    }
  }
}
img {
  width: 100%;
  height: 100%;
  vertical-align: top;
}
</style>
